'use client'

import { FiShoppingCart } from 'react-icons/fi'
import { useCartStore } from '@/stores/cartStore'
import { useCallback } from 'react'

export default function CartCountBadge() {
  // Sidebar open action
  
  // Get cart count from store
  const { items, openSidebar } = useCartStore()
  const itemCount = items.length
  
  const handleClick = useCallback(() => {
    openSidebar()
  }, [openSidebar])
  
  return (
    <button
      onClick={handleClick}
      className="relative p-2 text-text-main hover:text-primary transition"
      aria-label="View cart"
    >
      <FiShoppingCart className="h-6 w-6" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-primary text-bg-main text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount > 9 ? '9+' : itemCount}
        </span>
      )}
    </button>
  )
} 